import React from 'react';
import { FiGlobe, FiSmartphone, FiCode, FiShare2, FiArrowUpRight } from 'react-icons/fi';
import Reveal from '../../fx/Reveal';
import CascadeGrid from '../../fx/CascadeGrid';

const services = [
    {
        title: 'Web Application Pentesting',
        description: 'Comprehensive security assessment of web apps to identify and exploit vulnerabilities.',
        features: ['OWASP Top 10 coverage', 'Business logic testing', 'Authentication bypass'],
        icon: <FiGlobe size={22} />,
    },
    {
        title: 'Mobile App Security Testing',
        description: 'In-depth security analysis of iOS and Android applications.',
        features: ['Static & dynamic analysis', 'Secure storage testing', 'Client-side injection'],
        icon: <FiSmartphone size={22} />,
    },
    {
        title: 'API Security Assessment',
        description: 'Thorough evaluation of API endpoints for vulnerabilities and weaknesses.',
        features: ['Authorization flaws', 'Rate-limiting bypass', 'Data exposure analysis'],
        icon: <FiCode size={22} />,
    },
    {
        title: 'Infrastructure & AD',
        description: 'Comprehensive assessment of network infrastructure and Active Directory.',
        features: ['Privilege escalation', 'Lateral movement', 'Domain compromise'],
        icon: <FiShare2 size={22} />,
    },
];

const RedTeamServices = () => {
    return (
        <section id="services" className="relative bg-[#05060a] text-white px-6 md:px-16 py-24 overflow-hidden">
            <div className="absolute inset-0 bg-dots opacity-25 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto">
                <Reveal className="text-center mb-14">
                    <span className="pill tag inline-flex mb-4">SERVICES</span>
                    <h2 className="font-display text-4xl md:text-5xl font-bold">
                        Our red team <span className="text-gradient-red">offerings</span>
                    </h2>
                    <p className="text-gray-400 max-w-2xl mx-auto mt-3 text-lg">
                        Find vulnerabilities before malicious actors do. Strengthen your security posture.
                    </p>
                </Reveal>

                <CascadeGrid className="grid gap-6 md:grid-cols-2 lg:grid-cols-4" stagger={110}>
                    {services.map((s, i) => (
                        <div key={i} className="card p-6 h-full group relative">
                            <div className="absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-red-500/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                            <div className="w-12 h-12 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center text-red-400 mb-4">
                                {s.icon}
                            </div>
                            <h3 className="font-display text-lg font-semibold mb-2">{s.title}</h3>
                            <p className="text-gray-400 text-sm mb-4 leading-relaxed">{s.description}</p>
                            <ul className="text-sm text-gray-300 space-y-2 mb-5">
                                {s.features.map((f, j) => (
                                    <li key={j} className="flex items-start gap-2">
                                        <span className="text-red-500 mt-0.5">▸</span>
                                        <span>{f}</span>
                                    </li>
                                ))}
                            </ul>
                            <a href="#contact" className="inline-flex items-center gap-1 text-red-400 group-hover:text-red-300 font-semibold text-sm transition-colors">
                                Learn more <FiArrowUpRight />
                            </a>
                        </div>
                    ))}
                </CascadeGrid>
            </div>
        </section>
    );
};

export default RedTeamServices;
